webpackJsonp(["pages.sessions.new"],{

/***/ "./pages/sessions/new/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__username_validator__ = __webpack_require__("./pages/sessions/new/username_validator.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__signin_tabs_memoizer__ = __webpack_require__("./pages/sessions/new/signin_tabs_memoizer.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__oauth_remember_me__ = __webpack_require__("./pages/sessions/new/oauth_remember_me.js");




document.addEventListener('DOMContentLoaded', function () {
  new __WEBPACK_IMPORTED_MODULE_0__username_validator__["a" /* default */](); // eslint-disable-line no-new
  new __WEBPACK_IMPORTED_MODULE_1__signin_tabs_memoizer__["a" /* default */](); // eslint-disable-line no-new
  new __WEBPACK_IMPORTED_MODULE_2__oauth_remember_me__["a" /* default */]({ // eslint-disable-line no-new
    container: $('.omniauth-container')
  }).bindEvents();
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./pages/sessions/new/oauth_remember_me.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * OAuth-based login buttons have a separate "remember me" checkbox.
 *
 * Toggling this checkbox adds/removes a `remember_me` parameter to the
 * login buttons' href, which is passed on to the omniauth callback.
 **/

var OAuthRememberMe = function () {
  function OAuthRememberMe() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, OAuthRememberMe);

    this.container = opts.container || '';
    this.loginLinkSelector = '.oauth-login';
  }

  _createClass(OAuthRememberMe, [{
    key: 'bindEvents',
    value: function bindEvents() {
      $('#remember_me', this.container).on('click', this.toggleRememberMe);
    }

    // eslint-disable-next-line class-methods-use-this

  }, {
    key: 'toggleRememberMe',
    value: function toggleRememberMe(event) {
      var rememberMe = $(event.target).is(':checked');

      $('.oauth-login', this.container).each(function (i, element) {
        var href = $(element).attr('href');

        if (rememberMe) {
          $(element).attr('href', href + '?remember_me=1');
        } else {
          $(element).attr('href', href.replace('?remember_me=1', ''));
        }
      });
    }
  }]);

  return OAuthRememberMe;
}();

/* harmony default export */ __webpack_exports__["a"] = (OAuthRememberMe);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./pages/sessions/new/signin_tabs_memoizer.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_utils_accessor__ = __webpack_require__("./lib/utils/accessor.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



/**
 * Memorize the last selected tab after reloading a page.
 * Does that setting the current selected tab in the localStorage
 */

var SigninTabsMemoizer = function () {
  function SigninTabsMemoizer() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$currentTabKey = _ref.currentTabKey,
        currentTabKey = _ref$currentTabKey === undefined ? 'current_signin_tab' : _ref$currentTabKey,
        _ref$tabSelector = _ref.tabSelector,
        tabSelector = _ref$tabSelector === undefined ? 'ul.nav-tabs' : _ref$tabSelector;

    _classCallCheck(this, SigninTabsMemoizer);

    this.currentTabKey = currentTabKey;
    this.tabSelector = tabSelector;
    this.isLocalStorageAvailable = __WEBPACK_IMPORTED_MODULE_0__lib_utils_accessor__["a" /* default */].isLocalStorageAccessSafe();
    // sets selected tab if given as hash tag
    if (window.location.hash) {
      this.saveData(window.location.hash);
    }

    this.bootstrap();
  }

  _createClass(SigninTabsMemoizer, [{
    key: 'bootstrap',
    value: function bootstrap() {
      var _this = this;

      var tabs = document.querySelectorAll(this.tabSelector);
      if (tabs.length > 0) {
        tabs[0].addEventListener('click', function (e) {
          if (e.target && e.target.nodeName === 'A') {
            var anchorName = e.target.getAttribute('href');
            _this.saveData(anchorName);
          }
        });
      }

      this.showTab();
    }
  }, {
    key: 'showTab',
    value: function showTab() {
      var anchorName = this.readData();
      if (anchorName) {
        var tab = document.querySelector(this.tabSelector + ' a[href="' + anchorName + '"]');
        if (tab) {
          tab.click();
        }
      }
    }
  }, {
    key: 'saveData',
    value: function saveData(val) {
      if (!this.isLocalStorageAvailable) return undefined;

      return window.localStorage.setItem(this.currentTabKey, val);
    }
  }, {
    key: 'readData',
    value: function readData() {
      if (!this.isLocalStorageAvailable) return null;

      return window.localStorage.getItem(this.currentTabKey);
    }
  }]);

  return SigninTabsMemoizer;
}();

/* harmony default export */ __webpack_exports__["a"] = (SigninTabsMemoizer);

/***/ }),

/***/ "./pages/sessions/new/username_validator.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore__ = __webpack_require__("../../../node_modules/underscore/underscore.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_utils_axios_utils__ = __webpack_require__("./lib/utils/axios_utils.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__flash__ = __webpack_require__("./flash.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__locale__ = __webpack_require__("./locale/index.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable comma-dangle, consistent-return, class-methods-use-this, arrow-parens, no-param-reassign, max-len */






var debounceTimeoutDuration = 1000;
var invalidInputClass = 'gl-field-error-outline';
var successInputClass = 'gl-field-success-outline';
var unavailableMessageSelector = '.username .validation-error';
var successMessageSelector = '.username .validation-success';
var pendingMessageSelector = '.username .validation-pending';
var invalidMessageSelector = '.username .gl-field-error';

var UsernameValidator = function () {
  function UsernameValidator() {
    var _this = this;

    _classCallCheck(this, UsernameValidator);

    this.inputElement = $('#new_user_username');
    this.inputDomElement = this.inputElement.get(0);
    this.state = {
      available: false,
      valid: false,
      pending: false,
      empty: true
    };

    var debounceTimeout = __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.debounce(function (username) {
      _this.validateUsername(username);
    }, debounceTimeoutDuration);

    this.inputElement.on('keyup.username_check', function () {
      var username = _this.inputElement.val();

      _this.state.valid = _this.inputDomElement.validity.valid;
      _this.state.empty = !username.length;

      if (_this.state.valid) {
        return debounceTimeout(username);
      }

      _this.renderState();
    });

    // Override generic field validation
    this.inputElement.on('invalid', this.interceptInvalid.bind(this));
  }

  _createClass(UsernameValidator, [{
    key: 'renderState',
    value: function renderState() {
      // Clear all state
      this.clearFieldValidationState();

      if (this.state.valid && this.state.available) {
        return this.setSuccessState();
      }

      if (this.state.empty) {
        return this.clearFieldValidationState();
      }

      if (this.state.pending) {
        return this.setPendingState();
      }

      if (!this.state.available) {
        return this.setUnavailableState();
      }

      if (!this.state.valid) {
        return this.setInvalidState();
      }
    }
  }, {
    key: 'interceptInvalid',
    value: function interceptInvalid(event) {
      event.preventDefault();
      event.stopPropagation();
    }
  }, {
    key: 'validateUsername',
    value: function validateUsername(username) {
      var _this2 = this;

      if (this.state.valid) {
        this.state.pending = true;
        this.state.available = false;
        this.renderState();
        __WEBPACK_IMPORTED_MODULE_1__lib_utils_axios_utils__["a" /* default */].get(gon.relative_url_root + '/users/' + username + '/exists').then(function (_ref) {
          var data = _ref.data;
          return _this2.setAvailabilityState(data.exists);
        }).catch(function () {
          return Object(__WEBPACK_IMPORTED_MODULE_2__flash__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__locale__["__"])('An error occurred while validating username'));
        });
      }
    }
  }, {
    key: 'setAvailabilityState',
    value: function setAvailabilityState(usernameTaken) {
      if (usernameTaken) {
        this.state.valid = false;
        this.state.available = false;
      } else {
        this.state.available = true;
      }
      this.state.pending = false;
      this.renderState();
    }
  }, {
    key: 'clearFieldValidationState',
    value: function clearFieldValidationState() {
      this.inputElement.siblings('p').hide();

      this.inputElement.removeClass(invalidInputClass).removeClass(successInputClass);
    }
  }, {
    key: 'setUnavailableState',
    value: function setUnavailableState() {
      var $usernameUnavailableMessage = this.inputElement.siblings(unavailableMessageSelector);
      this.inputElement.addClass(invalidInputClass).removeClass(successInputClass);
      $usernameUnavailableMessage.show();
    }
  }, {
    key: 'setSuccessState',
    value: function setSuccessState() {
      var $usernameSuccessMessage = this.inputElement.siblings(successMessageSelector);
      this.inputElement.addClass(successInputClass).removeClass(invalidInputClass);
      $usernameSuccessMessage.show();
    }
  }, {
    key: 'setPendingState',
    value: function setPendingState() {
      var $usernamePendingMessage = $(pendingMessageSelector);
      if (this.state.pending) {
        $usernamePendingMessage.show();
      } else {
        $usernamePendingMessage.hide();
      }
    }
  }, {
    key: 'setInvalidState',
    value: function setInvalidState() {
      var $inputErrorMessage = $(invalidMessageSelector);
      this.inputElement.addClass(invalidInputClass).removeClass(successInputClass);
      $inputErrorMessage.show();
    }
  }]);

  return UsernameValidator;
}();

/* harmony default export */ __webpack_exports__["a"] = (UsernameValidator);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ })

},["./pages/sessions/new/index.js"]);


// WEBPACK FOOTER //
// pages.sessions.new.60a38c94bcbb1a563741.bundle.js